import { type FC } from 'react';
import { Grid, Stack } from '@mantine/core';
import { createPayoutTradersUrl } from '~/entities/payout';
import { useTraderEditor } from './lib';
import {
    TraderActionsCard,
    TraderEditorHeader,
    TraderProfileCard,
    TraderRateCard,
    TraderSettingsCard,
    TraderStateCard,
    TraderBalance,
} from './components';

interface TraderEditorProps {
    id: string;
}

export const TraderEditor: FC<TraderEditorProps> = ({ id }) => {
    const editor = useTraderEditor(id);

    return (
        <Stack
            gap='md'
            pos='relative'
        >
            {/* todo: сделать скелетоны*/}
            {/* <LoadingOverlay visible={editor.isTraderLoading} />*/}

            <TraderEditorHeader
                backUrl={createPayoutTradersUrl()}
                traderDisplayName={editor.traderDisplayName}
                status={editor.trader?.status}
            />

            <Grid gap='md'>
                <Grid.Col span={{ base: 12, md: 4 }}>
                    <Stack gap='md'>
                        <TraderProfileCard
                            fallbackTraderId={editor.requestedTraderId}
                            trader={editor.trader}
                        />

                        <TraderRateCard
                            trader={editor.trader}
                            traderId={editor.traderId}
                            fallbackTraderId={editor.requestedTraderId}
                            rateFormKey={editor.rateFormKey}
                            rate={editor.traderRate}
                            isRateError={editor.isTraderRateError}
                            isRateLoading={editor.isTraderRateLoading}
                            isUpdateRatePending={editor.editTraderRate.isPending}
                            onReloadRate={editor.handleReloadRate}
                            onUpdateRate={editor.handleUpdateRate}
                        />

                        <TraderStateCard
                            traderId={editor.traderId}
                            status={editor.trader?.status}
                            workingStatus={editor.trader?.workingStatus}
                            canEditWorkingStatus={editor.canEditWorkingStatus}
                            isWorkingStatusPending={editor.setWorkingStatus.isPending || editor.isTraderLoading}
                            onWorkingStatusChange={editor.handleSetWorkingStatus}
                        />

                        {editor.isTraderBalanceAvailable && (
                            <TraderBalance
                                balance={editor.rubTraderBalance}
                                isLoading={editor.isTraderBalanceLoading}
                            />
                        )}

                        <TraderActionsCard
                            traderId={editor.traderId}
                            status={editor.trader?.status}
                            isBlockPending={editor.block.isPending}
                            isUnBlockPending={editor.unBlock.isPending}
                            onBlock={editor.handleBlock}
                            onUnBlock={editor.handleUnBlock}
                        />
                    </Stack>
                </Grid.Col>

                <Grid.Col span={{ base: 12, md: 8 }}>
                    <TraderSettingsCard
                        trader={editor.trader}
                        traderId={editor.traderId}
                        fallbackTraderId={editor.requestedTraderId}
                        configFormKey={editor.configFormKey}
                        isActivatePending={editor.activate.isPending}
                        isUpdateConfigPending={editor.editTraderConfig.isPending}
                        onActivate={editor.handleActivate}
                        onUpdateConfig={editor.handleUpdateConfig}
                    />
                </Grid.Col>
            </Grid>
        </Stack>
    );
};
